module.exports = __webpack_public_path__ + "c204409dd66d104989de12704d461d8d.MP3";